var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPillsExamples(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 685,
    viewBox: "0 0 1920 685",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2010,
    y: 291,
    width: 521,
    height: 291,
    rx: 145.5,
    transform: "rotate(180 2010 291)",
    fill: "url(#paint0_radial_443_733)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 517.047,
    y: 330.876,
    width: 678.893,
    height: 377.075,
    rx: 188.538,
    transform: "rotate(148.606 517.047 330.876)",
    fill: "url(#paint1_radial_443_733)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_443_733",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2270 -386.5) rotate(86.6209) scale(984.416 1762.41)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868563,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_443_733",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(855.843 -547.022) rotate(86.602) scale(1275.62 2296.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868563,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillsExamples);
export default __webpack_public_path__ + "static/media/pills_examples.cb490cefb2b962af8d5bdf6068c5c97d.svg";
export { ForwardRef as ReactComponent };